import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class SignOutRequest {
  @jsonMember readonly refreshToken!: string;

  constructor(refreshToken: string) {
    this.refreshToken = refreshToken;
  }
}
